var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pulseLoader"},[_c('div',{attrs:{"id":"new_loader"}},[_c('div',{staticClass:"before_page_load"},[_c('div',{staticClass:"loader_pulse"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])])])
}]

export { render, staticRenderFns }